import appsData from './mock/apps'
import programData from './mock/programData'
import programMenu from './mock/programMenu'
import systemData from './mock/systemData.json'
import appTypeData from './mock/appTypes'
import appDeviceData from './mock/appDevice'
import programManualData from './mock/programManual.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import envs from '../../../envs.js'

// 시스템 리스트를 조회한다.
export function getSystems() {
  if (isUseAPI()) {
    return request({
      url: '/hiway/systeminfos',
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(appsData)
  })
}

// 시스템 정보와 조회할 프로그램 명을 기준으로 프로그램 리스트를 조회한다
export function getProgramData(retrieveObj) {
  // if (isUseAPI()) {
  // let url = '/hiway/programs'
  // let params = {}

  // if (retrieveObj.appId) url = `/hiway/programs/${retrieveObj.appId}`
  // if (retrieveObj.programNm) params = { pgm_nm: retrieveObj.programNm }
  // return request({
  //   url,
  //   method: 'get',
  //   params,
  //   meta: { apiVersion: '2.0.0' }
  // })

  if (isUseAPI()) {
    let params = {}
    if (retrieveObj.app_id) params['app_id'] = retrieveObj.app_id
    if (retrieveObj.pgm_nm) params['pgm_nm'] = retrieveObj.pgm_nm
    return request({
      url:
        `/hiway/programs/apps/` +
        retrieveObj.app_id +
        '?pgm_nm=' +
        retrieveObj.pgm_nm,
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }
  return new Promise(function(resolve, reject) {
    resolve(programData)
  })
}

// 시스템 정보와 조회할 프로그램 명을 기준으로 프로그램 리스트를 조회한다(Menu Popup)
export function getProgramMenu(retrieveObj) {
  if (isUseAPI()) {
    let params = {}
    if (retrieveObj.appId) params['appId'] = retrieveObj.appId
    if (retrieveObj.programNm) params['programNm'] = retrieveObj.programNm
    return request({
      url:
        `/hiway/programs/apps/` +
        retrieveObj.appId +
        '?pgm_nm=' +
        retrieveObj.programNm,
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }
  return new Promise(function(resolve, reject) {
    resolve(programMenu)
  })
}

export function getSystemData(retrieveObj) {
  if (isUseAPI()) {
    let url = '/hiway/systeminfos'
    let params = {}

    if (retrieveObj.appId) url = `/hiway/system/systeminfos/${retrieveObj.appId}`
    if (retrieveObj.systemNm) params = { operation: retrieveObj.operation, company: retrieveObj.company, systemNm: retrieveObj.systemNm }
    return request({
      url,
      method: 'get',
      params,
      meta: { apiVersion: '2.0.0' }
    })
  }
  return new Promise(function(resolve, reject) {
    resolve(systemData)
  })
}

// 시스템에 부여하는 회사명을 조회한다.
export function getCompanyTypeData() {
  if (isUseAPI()) {
    return request({
      url: '/hiway/common/code/SY001',
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(appTypeData)
  })
}

// 시스템에 부여하는 사업부명을 조회한다.
export function getOperationTypeData() {
  if (isUseAPI()) {
    return request({
      url: '/hiway/common/code/SY002',
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(appTypeData)
  })
}

// 프로그램에 부여하는 앱 타입을 조회한다.
export function getApptypeData() {
  if (isUseAPI()) {
    return request({
      url: '/hiway/common/code/SY005',
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(appTypeData)
  })
}

// 프로그램에 부여하는 Device을 조회한다.
export function getAppDevice() {
  if (isUseAPI()) {
    return request({
      url: '/hiway/common/code/SY012',
      method: 'get',
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(appDeviceData)
  })
}

// 파일 업로드 공용 API
export function uploadFile(file) {
  let data = new FormData()
  for (var i = 0; i < file.length; i++) {
    data.append('file', file[i])
  }
  if (isUseAPI()) {
    return request({
      url: '/hiway/files',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data,
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  return new Promise(function(resolve, reject) {
    let uuidv1 = require('uuid/v1')
    let faker = require('faker')
    // Mockup에서는 파일 업로드를 하면 id와 이름을 주게 한다.
    resolve({
      file_id: uuidv1(),
      file_nm: faker.lorem.word(),
      file_path: '/assets/icons/opened_folder.png'
    })
  })
}

// 파일로 추가를 위해, 파일 업로드 이후, 서버에서 fileId를 기반으로 로직 수행
export function appendFromFile(fileId) {
  if (isUseAPI()) {
    // 조회하는 기준 값은 locale
    return request({
      url: `/programs/file/${fileId}`,
      method: 'get'
    })
  }
}

export function getProgramManualData(locale, row) {
  if (isUseAPI()) {
    // 받은 데이터 값 중 프로그램 ID를 기준으로 메뉴얼(다국어)리스트를 가져온다.
    // 조회하는 기준 값은 locale
    return request({
      // url: `/hiway/manual/${row.pgm_id}/${locale}`,
      url: `/hiway/programs/apps/${row.app_id}/programs/${
        row.pgm_id
      }/manual/language/${locale}`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    let ret = _.cloneDeep(programManualData)
    ret[0].app_id = row.app_id
    ret[0].pgm_id = row.pgm_id
    ret[0].pgm_nm = row.pgm_nm
    resolve(ret)
  })
}

export function saveProgramManualData(locale, row) {
  if (isUseAPI()) {
    // 받은 데이터 값 중 프로그램 ID를 기준으로 메뉴얼(다국어)리스트를 저장한다.
    // 조회하는 기준 값은 locale
    // 수신측에서 app_id와 pgm_id 값을 기준으로, manual_id 값을 저장해야 함
    return request({
      url: `/hiway/manual/${row.pgm_id}/${locale}`,
      method: 'post',
      meta: { apiVersion: 'v2.0' },
      data: row
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}

export function saveSystemList(saveDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: '/hiway/systeminfos',
      method: 'post',
      data: saveDataSet,
      meta: {
        apiVersion: '2.0.0'
      }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}

// 프로그램 리스트를 저장한다.
export function saveProgramList(retrieveData, saveDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: `/hiway/programs/apps/${retrieveData.app_id}`,
      method: 'post',
      data: saveDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }
  return new Promise(function(resolve, reject) {
    let total = saveDataSet.created.length + saveDataSet.updated.length
    let resObj = getResultObj(total)
    resObj.created = [...saveDataSet.created]
    resObj.updated = [...saveDataSet.updated]
    resObj.created.forEach(row => {
      let ret = _.random(0, 1)
      row.ret_code = ret === 1 ? 'Y' : 'N'
      row.ret_msg = ret === 1 ? '반영완료' : '무슨문제가..'
      row.pgm_id = _.random(1000000, 9999999)
      row.is_change = ''
    })
    resObj.updated.forEach(row => {
      let ret = _.random(0, 1)
      row.ret_code = ret === 1 ? 'Y' : 'N'
      row.ret_msg = ret === 1 ? '반영완료' : '무슨문제가..'
      row.is_change = ''
    })
    resolve(resObj)
  })
}
export function deleteSystemList(deleteDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: '/hiway/systeminfos',
      method: 'delete',
      data: deleteDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(getResultObj(deleteDataSet.deleted.length))
  })
}
// 선택된 프로그램 리스트를 삭제한다.
export function deleteProgramList(retrieveData, deleteDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: `/hiway/programs/apps/${retrieveData.app_id}`,
      method: 'delete',
      data: deleteDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }
  return new Promise(function(resolve, reject) {
    resolve(getResultObj(deleteDataSet.deleted.length))
  })
}

function getResultObj(count) {
  let total = count
  let s = _.random(0, total)
  let f = total - s
  let e = _.random(100, 999)
  return {
    result: {
      total: {
        count: total,
        success: s,
        fail: f
      },
      execTime: e,
      resMsg: `${total}건 중, ${s}건 성공, ${f}건 실패. ${e}ms`
    }
  }
}

export function createSystemAuthToken(systemId) {
  if (isUseAPI()) {
    return request({
      url: '/hiway/authorization',
      method: 'post',
      data: { systemId: systemId },
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}

export function removeSystemAuthToken(systemId) {
  if (isUseAPI()) {
    return request({
      url: '/hiway/authorization',
      method: 'delete',
      data: { systemId: systemId },
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}
